import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChainLink2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChainLink2"><Path fillRule="evenodd" clipRule="evenodd" d="M1 6H9V7.5H2.5V16.5H9V18H1V6ZM15 6H23V18H15V16.5H21.5V7.5H15V6ZM6 11.25H18V12.75H6V11.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChainLink2;
